import React, { useState, useEffect } from 'react';
import api from '../api';

const SiteSwitcher = () => {
    const [sites, setSites] = useState([]);
    const [currentSite, setCurrentSite] = useState('');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                // 1. Get User Context (to know current site)
                const userRes = await api.get('users/me/');
                const currentId = userRes.data.current_site_id;

                // 2. Get Available Sites
                const sitesRes = await api.get('sites/');
                setSites(sitesRes.data);

                // 3. Logic: Sync Frontend with Backend
                if (currentId) {
                    // User already has a site selected on backend
                    setCurrentSite(currentId);
                } else if (sitesRes.data.length > 0) {
                    // PROBLEM SOLVER: User has sites, but backend selection is empty.
                    // Automatically select the first one to fix context.
                    const defaultSiteID = sitesRes.data[0].id;
                    await api.post(`sites/${defaultSiteID}/switch/`); // <--- The Fix
                    setCurrentSite(defaultSiteID);
                    
                    // We must reload so the rest of the app (Dashboard, Docs) 
                    // fetches data using this new context.
                    window.location.reload();
                }
            } catch (error) {
                console.error("Failed to load sites", error);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    const handleSwitch = async (e) => {
        const newId = e.target.value;
        if (!newId) return;

        try {
            await api.post(`sites/${newId}/switch/`);
            setCurrentSite(newId);
            window.location.reload(); 
        } catch (error) {
            alert("Failed to switch site");
        }
    };

    if (loading || sites.length === 0) return null;

    return (
        <div style={{ marginRight: '20px' }}>
            <select
                value={currentSite}
                onChange={handleSwitch}
                style={{
                    background: '#1e293b', 
                    color: 'white',
                    border: '1px solid #334155',
                    padding: '6px 12px',
                    borderRadius: '6px',
                    cursor: 'pointer',
                    fontSize: '0.85rem',
                    outline: 'none',
                    fontWeight: '500'
                }}
            >
                {sites.map(site => (
                    <option key={site.id} value={site.id}>
                        {site.code} - {site.name}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default SiteSwitcher;